import { useI18n } from "@core/i18n/i18n";
import styled from "@emotion/styled";
import { useDimensions } from "@ui/hooks/use-dimensions";
import { colors } from "@ui/style/colors";
import { motion } from "framer-motion";
import React from "react";

interface NoAlternativeExercisePlaceholderProps {
	onClick: () => void;
	display?: boolean;
}

export const NO_ALTERNATIVE_PLACEHOLDER_HEIGHT = 108;

export const NoAlternativeExercisePlaceholder: React.FC<NoAlternativeExercisePlaceholderProps> = ({
	onClick,
	display = true,
}) => {
	const { format } = useI18n();
	const { isDesktop } = useDimensions();
	return display ? (
		<Placeholder
			onClick={onClick}
			initial={{ opacity: 0 }}
			animate={{ opacity: 1 }}
			exit={{ opacity: 0 }}
			transition={{ ease: "easeInOut" }}
		>
			<Text className="p-size-xs-semi-bold">
				{format(
					isDesktop
						? "programBuilder.alternativeExercisePanel.noAlternativeExercisePlaceholder.title"
						: "programBuilder.alternativeExercisePanel.noAlternativeExercisePlaceholder.mobile_title",
				)}
				<LibraryContainer>{format("programBuilder.dayTable.noExercisePlaceholder.libraryTitle")}</LibraryContainer>
			</Text>
		</Placeholder>
	) : null;
};

const Text = styled.p`
	color: ${colors.grey};
	max-width: 60%;
`;

const LibraryContainer = styled.div`
	color: ${colors.primary};
	display: flex;
	place-items: center;
	place-content: center;
	gap: 4px;
`;

const Placeholder = styled(motion.div)`
	display: grid;
	cursor: pointer;
	place-content: center;
	place-items: center;
	text-align: center;
	border-radius: 8px;
	background-color: ${colors.primaryBackground};
	height: ${NO_ALTERNATIVE_PLACEHOLDER_HEIGHT}px;
	border: 1px dashed ${colors.primary};

	:hover {
		border-style: solid;
		background-color: ${colors.primaryBackground};
	}
`;
